import { useCallback, useEffect, useState } from 'react'

// utils
import { getApprovedERC721 } from '../../sushi/utils'
import { userNFTContract } from '../../userType/userNFTContract'
import { userExchangeNFTAddress } from '../../userType/userExchangeNFTAddress'
import { userBidNFTAddress } from '../../userType/userBidNFTAddress'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'
import useInterval from '../useInterval'
import { useMarketLevel } from '../../state/market/hooks'

const useAllowanceSell = (
  {
    tokenId,
    type,
    requested,
    reset
  }: {
    tokenId: string,
    type: string,
    requested?: boolean,
    reset?: boolean
  }
) => {
  const [allowance, setAllowance] = useState(false)
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  const level = useMarketLevel()
  let erc721Contract = userNFTContract(sushi, type)
  let address = ''
  if (level === 'v1') {
    address = userExchangeNFTAddress(sushi, type)
  } else {
    address = userBidNFTAddress(sushi, type)
  }

  const fetchAllowance = useCallback(async () => {
    if (account) {
      try {
        const allowance = await getApprovedERC721(erc721Contract, tokenId)
        setAllowance(allowance === address)
        // console.log('<<<-----allowance---', allowance, address, allowance === address, tokenId)
      } catch (e) {
        setAllowance(false)
      }
    }
  }, [account, erc721Contract, tokenId, address])

  useEffect(() => {
    if (account && erc721Contract && tokenId) {
      fetchAllowance()
    }
  }, [account, erc721Contract, tokenId, fetchAllowance])

  useInterval(fetchAllowance, reset || (requested && !allowance) ? 3000 : null)

  return allowance
}

export default useAllowanceSell
